import script from "./SelectVmsStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectVmsStep.vue?vue&type=script&setup=true&lang=js"

import "./SelectVmsStep.vue?vue&type=style&index=0&id=25d5874d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25d5874d"]])

export default __exports__